import { Box, Typography } from '@mui/material'
import { plcInfoCards } from '../../data/plcContent'
import FigmaIconFrame from '../common/FigmaIconFrame'

function InfoCard({ title, value, iconSrc, iconBgColor }) {
  return (
    <Box
      sx={{
        flex: { md: '1 1 0' },
        minWidth: 0,
        bgcolor: '#fffefa',
        borderRadius: '20px',
        boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.12)',
        p: '24px',
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center', width: '100%', minWidth: 0 }}>
        <FigmaIconFrame src={iconSrc} bgColor={iconBgColor} />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontSize: { xs: 22, md: 22 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, md: 16 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
              mt: '6px',
            }}
          >
            {value}
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default function PlcInfoCards() {
  return (
    <Box
      component="section"
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', lg: 'repeat(4, 1fr)' },
        gap: '24px',
        mt: { xs: 2, md: 6, lg: '150px' },
      }}
    >
      {plcInfoCards.map((card) => (
        <InfoCard key={card.title} {...card} />
      ))}
    </Box>
  )
}
